import helper from '../../helper';

export default {
	state: {
		fileId: {
			loading: false,
			id: {},
		},
		otherFileId: {
			loading: false,
			id: {},
		},
	},
	mutations: {
		requestFileId(state) {
			state.fileId.loading = true;
		},
		successFileId(state, data) {
			state.fileId.loading = false;
			state.fileId.id = data;
		},
		failFileId(state) {
			state.fileId.loading = false;
		},
		requestOtherFileId(state) {
			state.otherFileId.loading = true;
		},
		successOtherFileId(state, data) {
			state.otherFileId.loading = false;
			state.otherFileId.id = data;
		},
		failOtherFileId(state) {
			state.otherFileId.loading = false;
		},
	},
	actions: {
		getFileId({ commit }, params) {
			return helper(this, async () => {
				commit('requestFileId');
				const res = await a.api('exportYskAndXfList', params);
				commit('successFileId', res.result);
			});
		},
		getOtherFileId({ commit }, params) {
			return helper(this, async () => {
				commit('requestOtherFileId');
				const res = await a.api('exportNotYskAndXfList', params);
				commit('successOtherFileId', res.result);
			});
		},
	},
};
